import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import teamdetails from "../../services/teams.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class PayshiftsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    EventService,
    TeamsService,
    CompaniesService,
    SecurityService,
    $stateParams,
    CommonService,
    $rootScope,
    EnvService,
    $timeout,
    $location,
    ngProgressFactory
  ) {
    this.name = "payshifts";
    $localStorage.activeStateName = "payshifts";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$teams = TeamsService;
    this.$stateParams = $stateParams;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$common = CommonService;
    this.$rootScope = $rootScope;
    this.$events = EventService;
    this.$progress = ngProgressFactory.createInstance();
    this.$env = EnvService;
    this.remain_loading_count = 1;
    this.totalPayment = 0;
    this.$timeout = $timeout;
    this.totalMinutesWorkedForEntireJob = 0;
    this.totalPaymentDisplay = 0;
    this.allChecked = false;
    this.currentUser = this.$auth.getUserData();
    this.currentPageNumber = 1;
    this.disablePaymentButton = true;
    this.currentMarkers = [];
    this.paymentList = [];
    this.bulkCheck = false;
    this.$location = $location;
    this.invoice = false;

    var _this = this;

    this.getEvent();

    _this.organizePaymentOptions(_this.currentUser);
  }

  getEvent() {
    var _this = this;

    let eventId = this.$stateParams.eventId;

    _this.setLoader();

    _this.$events.getEventByIdTrimmedRoster(eventId).then(
      function (response) {
        _this.event = response.data;
        _this.setEventToSideBar();
        _this.sortShifts();
      },
      function (error) {
        alert("Something has gone wrong. Please contact support.");
      }
    );
  }

  setEventToSideBar() {
    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventToEventDialog", {
        event: _this.event,
      });
      _this.$rootScope.$emit("SetEventToEventSidebar", {
        event: _this.event,
      });
    }, 100);

    if (_this.event.isCompleted === true) {
      _this.$timeout(function () {
        $("eventsidebar .jobs-complete-sidebar  aside li:nth-child(6)").removeClass().addClass("active");
      }, 1500);
    } else {
      _this.$timeout(function () {
        $("eventsidebar .jobs-complete-sidebar  aside li:nth-child(9)").removeClass().addClass("active");
      }, 1500);
    }
  }

  sortShifts() {
    var _this = this;

    let shifts = _this.event.subEvents[0].deduppedJobbles[0].shifts;

    try {
      shifts.forEach(function (shift, index) {
        shift.startTimeFormatted = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("ddd MMM DD hh:mm A");
        shift.endTimeFormatted = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("ddd MMM DD hh:mm A");
      });
    } catch (err) {
      console.log("error processing shifts");
      console.dir(err);
    } finally {
      shifts.sort(function (a, b) {
        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
      });

      shifts[0].isActive = true;

      _this.findCallToActions(shifts);

      if (shifts.length === 1 && _this.event.isCompleted !== true) {
        _this.showCloseButton = true;
      } else if (shifts.length === 1 && _this.event.isCompleted === true) {
        _this.showReopenButton = true;
      }

      _this.shifts = shifts;

      if (_this.$location.$$search.shiftPosition) {
        _this.setActiveShift(_this.$location.$$search.shiftPosition);
      } else {
        _this.setActiveShift();
      }

      if (_this.$location.$$search.shiftId) {
        let s = {};
        s.id = _this.$location.$$search.shiftId;
        _this.getRosterForFirstShift(s);
      } else {
        _this.getRosterForFirstShift();
      }
    }
  }

  getRosterForFirstShift(shift) {
    var _this = this;

    let shiftId = null;

    if (shift) {
      shiftId = shift.id;
    } else {
      shiftId = _this.shifts[0].id;
    }

    _this.$events.getShiftsInSamePosition(shiftId).then(
      function (response) {
        let shiftsAndUsers = response.data;

        _this.sortByLastName(shiftsAndUsers);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  sortByLastName(shiftsAndUsers) {
    var _this = this;

    let users = [];
    let emptyShifts = [];

    shiftsAndUsers.forEach(function (shift) {
      if (shift.applicant) {
        shift.isCheckedForPayment = false;
        users.push(shift);
      } else {
        emptyShifts.push(shift);
      }

      shift.checkInMarkerSelected = false;
      shift.checkOutMarkerSelected = false;
    });

    users.sort(function (a, b) {
      if (a.applicant && b.applicant) {
        if (a.applicant.lastName < b.applicant.lastName) return -1;
        if (a.applicant.lastName > b.applicant.lastName) return 1;
        return 0;
      }
    });

    _this.emptyShifts = emptyShifts;
    _this.calculateTimeWorked(users);
  }

  checkUserForPayment(data) {
    var _this = this;

    if (data.isCheckedForPayment === true) {
      data.isCheckedForPayment = false;
      _this.removeUserFromPaymentList(data);
    } else {
      data.isCheckedForPayment = true;
      _this.addUserToPaymentList(data);
    }
  }

  removeUserFromPaymentList(data) {
    var _this = this;

    let x = _this.paymentList.findIndex((obj) => obj.id == data.id);

    _this.paymentList.splice(x, 1);
    _this.removeMinutesToTotal(data);
    _this.removeMoneyToTotal(data);
    _this.disablePaymentButtonFunc();
  }

  addUserToPaymentList(data) {
    var _this = this;

    _this.paymentList.push(data);
    _this.addMinutesToTotal(data);
    _this.addMoneyToTotal(data);
    _this.disablePaymentButtonFunc();
  }

  sendPaymentModal() {
    var _this = this;

    if (!_this.transferData && _this.invoice === true) {
      let req = {};
      req.card = null;
      _this.transferData = req;
    }

    _this.$timeout(function () {
      $("#modal-complete-event-confirm-modal-shifts").modal();
    });
  }

  closeEventModal() {
    var _this = this;

    _this.$timeout(function () {
      $("#modal-complete-event-close-job").modal();
    });
  }

  closeJob() {
    var _this = this;

    _this.setLoader();

    _this.$events.closeEvent(_this.event.id).then(
      function (response) {
        _this.unSetLoader();
        _this.$timeout(function () {
          _this.$state.go("jobsdashboard");
        }, 300);
      },
      function (error) {
        console.log("error");
        console.dir(error);
        _this.unSetLoader();
        alert("Error: " + error);
      }
    );
  }

  sendPayment() {
    var _this = this;

    let transferArray = [];

    _this.setLoader();
    _this.$progress.start();

    try {
      _this.paymentList.forEach(function (shift) {
        let data = {};
        let amount = shift.payment * 100;

        data.recipient = shift.applicant.username;
        if (_this.isModalPayment) {
          data.amount = _this.additionalMonies * 100;
        } else {
          data.amount = amount;
        }

        data.note = "Payment";
        data.shift = shift.id;

        transferArray.push(data);
      });
    } finally {
      console.log("what is the transfer array");
      console.dir(transferArray);

      if (!_this.transferData) {
        //invoice payment from modal
        _this.transferData = {};
      }

      _this.transferData.transfers = transferArray;

      console.log("transferData");
      console.dir(_this.transferData);

      _this.postPayment();
    }
  }

  postPayment() {
    var _this = this;

    _this.$events.payUsersByShift(_this.transferData).then(
      function (response) {
        console.log("response");
        console.dir(response);
        _this.$progress.complete();
        _this.findUsersInTransferAndUpdateUI();
        _this.allChecked = false;
        _this.transferData = {};
        _this.paymentList = [];
        _this.totalPayment = 0;
        _this.totalMinutesWorkedForEntireJob = 0;
        _this.disablePaymentButton = true;
        _this.additionalMonies = 0;
        //_this.isModalPayment = false;
        _this.totalPaymentDisplay = 0;
        _this.unSetLoader();
        _this.uncheckPaymentInfo();
      },
      function (error) {
        _this.$progress.complete();
        _this.unSetLoader();
        console.log("transfer error");
        console.dir(error);
        alert("Error : " + error);
      }
    );
  }

  findUsersInTransferAndUpdateUI() {
    var _this = this;

    console.log("findUsersInTransferAndUpdateUI");
    console.log("_this.transferData_this.transferData_this.transferData_this.transferData");
    console.dir(_this.transferData);
    console.dir(_this.shiftsWithUsers);

    try {
      _this.transferData.transfers.forEach(function (item, i) {
        console.log("each transfer");
        console.dir(item);

        let x = _this.shiftsWithUsers.findIndex((obj) => obj.applicant.username == item.recipient);

        console.log("_this.shiftsWithUsers[x]");
        console.dir(_this.shiftsWithUsers[x]);
        console.dir(_this.isModalPayment);

        _this.shiftsWithUsers[x].hasBeenPaid = true;
        _this.shiftsWithUsers[x].hasNoPaymentInfo = false;

        if (_this.isModalPayment) {
          console.log("we should be here");

          _this.shiftsWithUsers[x].payment = ((_this.shiftsWithUsers[x].payment * 100 + item.amount) / 100).toFixed(2);
        }

        _this.shiftsWithUsers[x].isCheckedForPayment = false;
      });
    } finally {
      console.log("what is the shift with users after some processing");
      console.dir(_this.shiftsWithUsers);
      if (_this.isModalPayment) {
        _this.isModalPayment = false;
        _this.exit();
      }
    }
  }

  uncheckPaymentInfo() {
    var _this = this;

    _this.paymentInfos.forEach(function (info) {
      info.isChecked = false;
    });
  }

  setCardToPayment(data, isModalPayment) {
    var _this = this;

    console.log("setCardToPayment");
    console.dir(data);

    if (isModalPayment) {
      _this.isModalPayment = true;
    }

    let req = {};

    _this.uncheckPaymentInfo();

    if (data.isChecked === true) {
      data.isChecked = false;
      req.card = null;
    } else {
      data.isChecked = true;
      req.card = data.cardToken;
    }

    _this.transferData = req;

    console.log("transfer data");
    console.dir(_this.transferData);
    console.dir(_this.paymentList);

    if (isModalPayment) {
      if (_this.transferData.card !== null && _this.additionalMonies > 4) {
        console.log("additionmondies");
        console.dir(_this.additionalMonies);
        _this.disablePaymentButton = false;
      } else {
        _this.disablePaymentButton = true;
      }
    } else {
      if (_this.transferData.card !== null && _this.paymentList.length > 0) {
        _this.disablePaymentButton = false;
      } else {
        _this.disablePaymentButton = true;
      }
    }
  }

  addMinutesToTotal(data) {
    var _this = this;

    let mins = null;

    if (data.actualMinutesWorked === null) {
      mins = data.totalMinutes;
    } else {
      mins = data.actualMinutesWorked;
    }

    _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob + mins;
  }

  removeMinutesToTotal(data) {
    var _this = this;

    let mins = null;

    console.log("removeMinutesToTotal");
    console.dir(data);
    console.dir(_this.totalMinutesWorkedForEntireJob);

    if (data.actualMinutesWorked === null) {
      mins = data.totalMinutes;
    } else {
      mins = data.actualMinutesWorked;
    }

    _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob - mins;

    console.log("at the end...");
    console.dir(_this.totalMinutesWorkedForEntireJob);
  }

  setEditing(data, val, index) {
    var _this = this;

    let i = index + 1;

    console.log("what is the value");
    console.dir(val);

    if (data.hasBeenPaid === true) {
      return;
    }

    if (data.noShow === true) {
      return;
    }

    if (data.isCheckedForPayment === true) {
      return;
    }

    if (val === "hours") {
      data.isEditingHours = true;
    } else {
      data.isEditingMinutes = true;
    }

    //data.isEditing = true;

    console.log("check jquery");
    console.dir(val);
    console.dir($("table.table.table-bordered.shiftpayments:first-child tbody tr td input"));
    console.log("what is the data after all this");
    console.dir(data);
    /*
		_this.$timeout(function(){
			$('table.table.table-bordered.shiftpayments:first-child tbody tr td input').get(i).focus();
		},50);
		*/
  }

  calculateTimeWorked(users) {
    var _this = this;

    try {
      users.forEach(function (user) {
        let hours = null;
        let minutes = null;
        let hoursRounded = null;
        let momentET = null;
        let momentST = null;
        let totalMinutes = null;
        let minutesMod = null;

        user.isEditingHours = false;
        user.isEditingMinutes = false;

        if (user.actualMinutesWorked !== null) {
          console.log("we have actualMinutes worked data");

          totalMinutes = user.actualMinutesWorked;
          hoursRounded = Math.floor(totalMinutes / 60);
          minutesMod = totalMinutes % 60;

          console.log("final times");
          console.dir(hoursRounded);
          console.dir(minutesMod);

          if (user.paymentStats.amount === null) {
            user.payment = ((totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour) / 100 / 60).toFixed(2);
          } else {
            user.payment = (user.paymentStats.amount / 100).toFixed(2);
          }

          console.log("user.payment");
          console.dir((totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour) / 100 / 60);
          console.dir(user.payment);
          user.totalMinutes = totalMinutes;
          user.timeInterval.timeInHours = hoursRounded;
          user.timeInterval.timeInMinutes = minutesMod;
        } else {
          console.log("no we have actualMinutes worked data");
          console.dir(user);

          momentET = moment(user.timeInterval.endTime).tz("America/New_York");
          momentST = moment(user.timeInterval.startTime).tz("America/New_York");

          totalMinutes = moment(momentET).diff(moment(momentST), "minutes");
          user.totalMinutes = totalMinutes;
          hoursRounded = Math.floor(totalMinutes / 60);
          minutesMod = totalMinutes % 60;

          console.log("final times");
          console.dir(hoursRounded);
          console.dir(minutesMod);

          if (user.paymentStats.amount === null) {
            user.payment = ((totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour) / 100 / 60).toFixed(2);
          } else {
            user.payment = (user.paymentStats.amount / 100).toFixed(2);
          }

          console.log("user.payment");
          console.dir((totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour) / 100 / 60);
          console.dir(user.payment);

          user.timeInterval.timeInHours = hoursRounded;
          user.timeInterval.timeInMinutes = minutesMod;
        }

        if (user.paymentStats.amount !== null) {
          user.hasBeenPaid = true;
        }

        if (user.hasBeenPaid !== true) {
          if (user.applicant.undeletedPaymentInfos) {
            console.log("what are the undeleted payment infos");
            console.dir(user.applicant.undeletedPaymentInfos);
            if (user.applicant.undeletedPaymentInfos.length === 0 && user.applicant.currentPaymentMethod === null) {
              user.hasNoPaymentInfo = true;
            }
          }
        }

        if (user.checkInTime) {
          user.checkInTimeFormat = moment(user.checkInTime).tz(user.contactInfo.place.timeZoneId).format("hh:mm A");
        }

        if (user.checkOutTime) {
          user.checkOutTimeFormat = moment(user.checkOutTime).tz(user.contactInfo.place.timeZoneId).format("hh:mm A");
        }
      });
    } catch (err) {
      console.log("in loop error");
      console.dir(err);
    } finally {
      _this.$timeout(function () {
        _this.shiftsWithUsers = users;
        _this.initializeMap();
        _this.initializeToolTip();
      }, 300);

      _this.$timeout(function () {
        _this.unSetLoader();
      }, 300);
    }
  }

  initializeToolTip() {
    this.$timeout(() => {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }, 500);
  }

  initializeMap() {
    var _this = this;

    let mapBoxKey = _this.$env.EnvironmentConfig.mapbox;

    mapboxgl.accessToken = mapBoxKey;

    console.log("lets take a look at contact info");
    console.dir(_this.event.contactInfo);

    let zip = _this.event.contactInfo.zipCode;
    let street = _this.event.contactInfo.streetLine1;
    let city = _this.event.contactInfo.city;
    let state = _this.event.contactInfo.state;

    let location = street + " " + city + ", " + state + " " + zip;
    //_this.event

    console.log("final location");
    console.dir(location);

    var mapboxClient = mapboxSdk({accessToken: mapboxgl.accessToken});

    mapboxClient.geocoding
      .forwardGeocode({
        query: location,
        autocomplete: false,
        limit: 1,
      })
      .send()
      .then(function (response) {
        if (response && response.body && response.body.features && response.body.features.length) {
          var feature = response.body.features[0];

          console.log("feature", feature);

          let options = {};

          options.color = "#000";
          options.scale = 2;
          options.anchor = "bottom";

          var map = new mapboxgl.Map({
            container: "mapbox",
            style: "mapbox://styles/mapbox/streets-v11",
            center: feature.center,
            zoom: 11,
          });

          new mapboxgl.Marker(options).setLngLat(feature.center).addTo(map);

          _this.map = map;
          _this.plotUsers(map);
        } else {
          alert("There was an issue finding the location of the job.");
        }
      });
  }

  plotUsers(map) {
    var _this = this;

    console.log("plot users");
    console.dir(map);
    console.dir(_this.shiftsWithUsers);

    let arrayOfUsersAndCoords = [];

    /*
		let geoJson = {
			'type': 'geojson',
			'data': {
				'type': 'FeatureCollection',
				'features': []
			}
		}
		*/

    _this.shiftsWithUsers.forEach(function (data) {
      if (data.checkInCoord) {
        if (data.checkInCoord.lat && data.checkInCoord.lng) {
          arrayOfUsersAndCoords.push(data);

          let options = {};

          let note = null;

          if (data.jobblerNote) {
            note = data.jobblerNote;
          } else {
            note = "--";
          }

          options.color = "#74cf59";
          let popUpText =
            "<div id='mapPopup'><h4>" +
            data.applicant.firstName +
            " " +
            data.applicant.lastName +
            "</h4></div><div class='note-holder'> <strong>Note:</strong> " +
            note +
            "</div>";
          let currentMarker = new mapboxgl.Marker(options)
            .setLngLat([data.checkInCoord.lng, data.checkInCoord.lat])
            .setPopup(new mapboxgl.Popup().setHTML(popUpText))
            .addTo(_this.map);

          _this.currentMarkers.push(currentMarker);
        }
      }

      if (data.checkOutCoord) {
        if (data.checkOutCoord.lat && data.checkOutCoord.lng) {
          arrayOfUsersAndCoords.push(data);

          let options = {};

          let note = null;

          if (data.jobblerNote) {
            note = data.jobblerNote;
          } else {
            note = "--";
          }

          options.color = "#dc3545";
          let popUpText =
            "<div id='mapPopup'><h4>" +
            data.applicant.firstName +
            " " +
            data.applicant.lastName +
            "</h4></div><div class='note-holder'> <strong>Note:</strong> " +
            note +
            "</div>";
          let currentMarker = new mapboxgl.Marker(options)
            .setLngLat([data.checkOutCoord.lng, data.checkOutCoord.lat])
            .setPopup(new mapboxgl.Popup().setHTML(popUpText))
            .addTo(_this.map);

          _this.currentMarkers.push(currentMarker);
        }
      }
    });
  }

  clearIconForRest(data) {
    var _this = this;

    console.log("clearIconForRest");
    console.dir(data);

    _this.shiftsWithUsers.forEach(function (item) {
      console.log("each item");
      console.dir(item);
      if (item.id !== data.id) {
        item.checkOutMarkerSelected = false;
        item.checkInMarkerSelected = false;
      }
    });
  }

  determineEyeIconCheckIn(data) {
    var _this = this;

    console.log("determineEyeIconCheckIn");
    console.dir(data);

    if (data.checkInMarkerSelected === false) {
      data.checkOutMarkerSelected = false;
      data.checkInMarkerSelected = true;

      _this.clearIconForRest(data);
    } else {
      data.checkInMarkerSelected = false;
      data.checkOutMarkerSelected = false;
      _this.clearMarkers();
    }
  }

  determineEyeIconCheckOut(data) {
    var _this = this;

    console.log("determineEyeIconCheckOut");
    console.dir(data);

    if (data.checkOutMarkerSelected === false) {
      data.checkOutMarkerSelected = true;
      data.checkInMarkerSelected = false;
      _this.clearIconForRest(data);
    } else {
      data.checkOutMarkerSelected = false;
      data.checkInMarkerSelected = false;
      _this.clearMarkers();
    }
  }

  clearMarkers() {
    var _this = this;

    console.log("clearMarkersForCheckOut");
    console.dir(_this.currentMarkers);

    if (_this.currentMarkers.length > 0) {
      try {
        _this.currentMarkers.forEach(function (marker) {
          console.log("each marker");
          console.dir(marker);
          marker.remove();
        });
      } catch (err) {
        console.log("error removing markerings");
        console.dir(err);
      }
    }
  }

  clearMarkersForCheckIn(data) {
    var _this = this;

    console.log("clearMarkersForCheckOut");
    console.dir(data);
    console.dir(_this.currentMarkers);

    if (_this.currentMarkers.length > 0) {
      try {
        _this.currentMarkers.forEach(function (marker) {
          console.log("each marker");
          console.dir(marker);
          marker.remove();
        });
      } catch (err) {
        console.log("error removing markerings");
        console.dir(err);
      } finally {
        _this.placeSingleCheckinMarker(data);
      }
    }
  }

  placeSingleCheckinMarker(data) {
    var _this = this;

    console.log("placeSingleCheckinMarker");
    console.dir(data);
    if (data.checkInCoord) {
      if (data.checkInCoord.lat && data.checkInCoord.lng) {
        let options = {};

        let note = null;

        if (data.jobblerNote) {
          note = data.jobblerNote;
        } else {
          note = "--";
        }

        options.color = "#74cf59";
        let popUpText =
          "<div id='mapPopup'><h4>" +
          data.applicant.firstName +
          " " +
          data.applicant.lastName +
          "</h4></div><div class='note-holder'> <strong>Note:</strong> " +
          note +
          "</div>";
        let currentMarker = new mapboxgl.Marker(options)
          .setLngLat([data.checkInCoord.lng, data.checkInCoord.lat])
          .setPopup(new mapboxgl.Popup().setHTML(popUpText))
          .addTo(_this.map);

        _this.currentMarkers.push(currentMarker);
        _this.determineEyeIconCheckIn(data);
      } else {
        alert("This user does not have any check in coordinates");
      }
    } else {
      alert("This user does not have any checkin coordinates");
    }
  }

  placeSingleCheckOutMarker(data) {
    var _this = this;

    console.log("placeSingleCheckOutMarker");
    console.dir(data);
    if (data.checkOutCoord) {
      if (data.checkOutCoord.lat && data.checkOutCoord.lng) {
        let options = {};

        let note = null;

        if (data.jobblerNote) {
          note = data.jobblerNote;
        } else {
          note = "--";
        }

        options.color = "#dc3545";
        let popUpText =
          "<div id='mapPopup'><h4>" +
          data.applicant.firstName +
          " " +
          data.applicant.lastName +
          "</h4></div><div class='note-holder'> <strong>Note:</strong> " +
          note +
          "</div>";
        let currentMarker = new mapboxgl.Marker(options)
          .setLngLat([data.checkOutCoord.lng, data.checkOutCoord.lat])
          .setPopup(new mapboxgl.Popup().setHTML(popUpText))
          .addTo(_this.map);

        _this.currentMarkers.push(currentMarker);
        _this.determineEyeIconCheckOut(data);
      } else {
        alert("This user does not have any checkout coordinates");
      }
    } else {
      alert("This user does not have any checkout coordinates");
    }
  }

  clearMarkersForCheckOut(data) {
    var _this = this;

    console.log("clearMarkersForCheckOut");
    console.dir(data);
    console.dir(_this.currentMarkers);

    if (_this.currentMarkers.length > 0) {
      try {
        _this.currentMarkers.forEach(function (marker) {
          console.log("each marker");
          console.dir(marker);
          marker.remove();
        });
      } catch (err) {
        console.log("error removing markerings");
        console.dir(err);
      } finally {
        _this.placeSingleCheckOutMarker(data);
      }
    }
  }

  updateHoursWorked(data) {
    var _this = this;

    //after this is called we can calculate what they are owed with the below funnction

    console.log("updateHoursWorked");
    console.dir(data);

    let minutes = data.timeInterval.timeInHours * 60;
    let shiftId = data.id;

    minutes = minutes + data.timeInterval.timeInMinutes;

    console.log("total minutes");
    console.dir(minutes);

    _this.setLoader();

    data.actualMinutesWorked = minutes;

    _this.$events.updateActualMinutesWorkedForShift(shiftId, minutes).then(
      function (response) {
        console.log("response");
        console.dir(response);
        _this.unSetLoader();

        _this.updateCostOfWork(data);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
        _this.unSetLoader();
      }
    );
  }

  updateCostOfWork(data) {
    var _this = this;

    console.dir("updateCostOfWork");
    console.dir(data);

    data.payment = ((data.actualMinutesWorked * _this.event.subEvents[0].deduppedJobbles[0].payPerHour) / 100 / 60).toFixed(2);
  }

  enterHoursUpdated(data) {
    var _this = this;

    console.log("enterHoursUpdated");
    console.dir(data);

    data.isEditingHours = false;
    data.isEditingMinutes = false;

    _this.updateHoursWorked(data);
    /*
		_this.$timeout(function(){
			$('#modal-edit-shifts .modal-body .has-focus-job').focus();
		});
		*/
  }

  blurHoursUpdated(data) {
    var _this = this;

    console.log("blurHoursUpdated");
    console.dir(data);

    data.isEditingHours = false;
    data.isEditingMinutes = false;

    _this.updateHoursWorked(data);
  }

  checkForCallToActionFunc(list) {
    var _this = this;

    console.log("checkForCallToActionFunc");
    console.dir(list);
  }

  loadDifferentShifts(shift, index) {
    var _this = this;

    let checkForCallToActionArray = _this.shiftsWithUsers;

    let plusOne = index + 1;

    console.log("compare");
    console.dir(_this.shifts.length);
    console.dir(index);
    console.dir(plusOne);
    if (_this.shifts.length === plusOne && _this.event.isCompleted !== true) {
      _this.showCloseButton = true;
    } else {
      _this.showCloseButton = false;
    }
    if (_this.shifts.length === plusOne && _this.event.isCompleted === true) {
      _this.showReopenButton = true;
    } else {
      _this.showReopenButton = false;
    }
    _this.checkForCallToActionFunc(checkForCallToActionArray);
    _this.paymentList = [];

    console.log("loadDifferentShifts");
    console.dir(shift);
    console.dir(index);
    console.dir($(".shift-dates-holder ul li.active"));

    _this.setLoader();

    _this.totalMinutesWorkedForEntireJob = 0;
    _this.totalPaymentDisplay = 0;
    _this.totalPayment = 0;
    _this.allChecked = false;
    _this.disablePaymentButton = true;
    _this.bulkCheck = false;

    if (shift.isActive) {
      return;
    } else {
      try {
        _this.shifts.forEach(function (s) {
          s.isActive = false;
        });
      } finally {
        shift.isActive = true;
      }
    }

    let child = index + 1;

    _this.getRosterForFirstShift(shift);

    _this.$timeout(function () {
      $(".shift-dates-holder ul li.active").removeClass("active");
    });

    _this.$timeout(function () {
      $(".shift-dates-holder ul li:nth-child(" + child + "").addClass("active");
    }, 100);

    _this.switchTablesToNewShift(shift);
  }

  switchTablesToNewShift(shift) {
    var _this = this;

    _this.$timeout(function () {
      $("table.table.table-bordered.shiftpayments:first-child").hide("slide", {direction: "left"}, 200);
    }, 100);

    _this.$timeout(function () {
      _this.shiftsWithUsers = [];
    }, 300);

    _this.$timeout(function () {
      $("table.table.table-bordered.shiftpayments:first-child").show("slide", {direction: "right"}, 500);
    }, 900);
  }

  setActiveShift(position) {
    var _this = this;

    console.log("setActiveShift");
    console.dir(_this.$state);
    console.dir(_this.$location);
    console.log("url params");
    console.dir(position);

    if (position) {
      _this.$timeout(function () {
        $(".shift-dates-holder ul li:nth-child(" + position + ")").addClass("active");
      });
    } else {
      _this.$timeout(function () {
        $(".shift-dates-holder ul li:first-child").addClass("active");
      });
    }

    _this.remain_loading_count = 0;
  }

  organizePaymentOptions(user) {
    var _this = this;

    console.log("organizePaymentOptions");
    console.dir(user);

    let paymentOptions = [];
    let banks = [];

    if (_this.currentUser.company.payByInvoice === true) {
      _this.paymentInfos = [];
      _this.banks = [];
      _this.invoice = true;
    } else {
      _this.invoice = false;

      try {
        if (user.company.undeletedPaymentInfos) {
          user.company.undeletedPaymentInfos.forEach(function (info) {
            if (info.bankName === null) {
              paymentOptions.push(info);
            } else {
              console.log("here is the bank...");
              console.dir(info);
              if (info.validated === true) {
                info.cardBrand = info.bankName;
                paymentOptions.push(info);
              }
            }
          });
        }
      } catch (err) {
      } finally {
        _this.paymentInfos = paymentOptions;
        _this.banks = banks;
      }
    }
  }

  totalHoursWorkedForEvent() {
    var _this = this;

    var div = _this.totalMinutesWorkedForEntireJob / 60;

    return Math.floor(div);
  }

  totalMinutesWorkedForEvent() {
    var _this = this;
    //console.log("where is this set......");
    //console.dir(_this.totalMinutesWorkedForEntireJob);
    return _this.totalMinutesWorkedForEntireJob % 60;
  }

  checkAll() {
    var _this = this;

    if (_this.bulkCheck === false) {
      _this.bulkCheck = true;
      _this.checkAllJobblers(true);
      _this.allChecked = true;
    } else {
      _this.bulkCheck = false;
      _this.checkAllJobblers(false);
      _this.allChecked = false;
    }
  }

  checkAllJobblers(val) {
    var _this = this;

    console.log("check all jobblers");
    console.dir(val);
    console.dir(_this.bulkCheck);
    console.dir(_this.shiftsWithUsers);

    try {
      if (val === true) {
        _this.shiftsWithUsers.forEach(function (user) {
          if (user.noShow !== true && user.hasBeenPaid !== true && user.isCheckedForPayment) {
            user.isCheckedForPayment = false;
            _this.removeMinutesToTotal(user);
            _this.removeMoneyToTotal(user);
            _this.removeAllUsersFromPaymentList();
          }
        });
      }
    } catch (err) {
      console.log("in error");
      console.dir(err);
    } finally {
      _this.shiftsWithUsers.forEach(function (user) {
        if (user.noShow !== true && user.hasBeenPaid !== true) {
          user.isCheckedForPayment = val;

          if (val === false) {
            _this.removeMinutesToTotal(user);
            _this.removeMoneyToTotal(user);
            _this.removeAllUsersFromPaymentList();
          } else {
            _this.paymentList.push(user);
            _this.addMinutesToTotal(user);
            _this.addMoneyToTotal(user);

            console.log("kkkkk in the else right now");
            console.dir(_this.totalMinutesWorkedForEntireJob);
            console.dir(_this.totalPaymentDisplay);
            console.dir(_this.totalPayment);
            console.dir(_this.paymentList);
          }
        }
      });
    }
  }

  removeAllUsersFromPaymentList() {
    var _this = this;

    _this.paymentList.splice(0, _this.paymentList.length);
    _this.disablePaymentButtonFunc();
  }

  disablePaymentButtonFunc() {
    var _this = this;

    console.log("disablePaymentButtonFunc");
    console.dir(_this.paymentList);
    console.dir(_this.invoice);
    console.dir(_this.transferData);

    if (_this.paymentList.length > 0 && _this.invoice === true) {
      _this.disablePaymentButton = false;
    } else if (_this.invoice !== true && _this.transferData && _this.paymentList.length > 0) {
      _this.disablePaymentButton = false;
    } else if (_this.paymentList.length == 0) {
      _this.disablePaymentButton = true;
    }
  }

  removeMoneyToTotal(data) {
    var _this = this;

    console.log("remove money");
    console.dir(data);

    let pay = parseFloat(data.payment);

    console.dir(numeral(_this.totalPayment + pay).format("$0,0.00"));

    _this.totalPayment = _this.totalPayment - pay;

    _this.totalPaymentDisplay = numeral(_this.totalPayment).format("$0,0.00");
  }

  addMoneyToTotal(data) {
    var _this = this;

    console.log("add money kkkk");
    console.dir(data);

    let pay = parseFloat(data.payment);

    console.dir(numeral(_this.totalPayment + pay).format("$0,0.00"));

    _this.totalPayment = _this.totalPayment + pay;

    _this.totalPaymentDisplay = numeral(_this.totalPayment).format("$0,0.00");

    _this.disablePaymentButtonFunc();
  }

  totalAmountToBePaidOut() {
    var _this = this;

    //console.log("_this.currentUser.company.defaultPlan.companyFeePct");
    //console.dir(_this.currentUser.company.defaultPlan.companyFeePct);

    return _this.totalPaymentDisplay;
  }

  setLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  markUserForNoShowForShift(data, value) {
    var _this = this;

    console.log("markUserForNoShowForShift");
    console.log("hello marisa");
    console.dir(data);

    let shiftId = data.id;
    //let value = null;

    if (data.noShow === true) {
      //value = false;
      data.noShow = false;
    } else {
      //value = true;
      data.noShow = true;
      data.actualMinutesWorked = 0;
      data.timeInterval.timeInHours = 0;
      data.timeInterval.timeInMinutes = 0;
      data.payment = 0;
    }

    _this.setLoader();

    _this.$events.markUserAsNowShowForShift(shiftId, value).then(
      function (response) {
        console.log("response");
        console.dir(response);

        _this.$timeout(function () {
          _this.unSetLoader();
        }, 1000);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
        _this.$timeout(function () {
          _this.unSetLoader();
        }, 1000);
      }
    );
  }

  exit() {
    this.$timeout(() => {
      $("#additional-shift-payment").modal("hide");
    });
  }

  displayAdditionalPaymentModal(data) {
    console.log("displayAdditionalPaymentModal");
    console.dir(data);
    this.paymentList = [];
    this.additionalMonies = 0.0;
    this.payUser = data;
    this.collectPaymentMethods();
    this.paymentList.push(data);
    this.isModalPayment = true;
    this.$timeout(() => {
      $("#additional-shift-payment").modal();
    });
  }

  sendAdditionalPayment() {
    this.sendPayment();
  }

  findCallToActions(shifts) {
    var _this = this;
  }

  formComplete() {
    console.log("formComplete");
  }

  moniesChanging() {
    if (angular.isUndefined(this.moniesChanging)) {
      this.moniesChanging = 0;
    }

    if (this.company.payByInvoice === true) {
      if (this.additionalMonies > 4) {
        this.disablePaymentButton = false;
      } else {
        this.disablePaymentButton = true;
      }
    } else {
      if (this.transferData.card !== null && this.additionalMonies > 4) {
        this.disablePaymentButton = false;
      } else {
        this.disablePaymentButton = true;
      }
    }

    console.log("moniesChanging");
    console.dir(this.additionalMonies);
  }

  collectPaymentMethods() {
    var _this = this;
    console.log("collectPaymentMethods");
    console.dir(_this.currentUser);

    _this.$auth.getCompanyPayInfo().then(
      function (response) {
        let company = response.data.company;

        console.log("company");
        console.dir(company);

        _this.company = company;
      },
      function (error) {
        alert("Error getting company payment information " + error);
      }
    );
  }

  reOpenJob() {
    var _this = this;

    let id = _this.event.id;

    _this.setLoader();
    _this.$events.reOpenEvent(id).then(
      function (response) {
        console.log("what is the response");
        console.dir(response);
        if (response.status === 200) {
          _this.event.isCompleted = false;
          _this.event.isClosed = false;
          alert("Your job has been re-opened.");
          _this.$timeout(function () {
            _this.$state.go("jobsdashboard");
          }, 300);
        } else {
          console.log("there was an issue..");
        }
        _this.unSetLoader();
      },
      function (error) {
        console.log("what is the error");
        console.dir(error);
        _this.unSetLoader();
      }
    );
  }
}

PayshiftsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "teams",
  "companies",
  "security",
  "$stateParams",
  "common",
  "$rootScope",
  "env",
  "$timeout",
  "$location",
  "ngProgressFactory",
];

export default PayshiftsController;



// WEBPACK FOOTER //
// ./client/app/components/payshifts/payshifts.controller.js